import NavigateNextIcon from "@mui/icons-material/NavigateNext.js";
import {Box, Breadcrumbs, Link, Typography} from "@mui/material";
import HomeIcon from "@mui/icons-material/Home.js";
import React from "react";


export const Crumbs = (props) => {

    let crumbList = []
    if (props.crumbs === undefined) {
        crumbList.push(<Box key={"home"}><HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />Home</Box>)
    } else {
        crumbList.push(<Link
            key={"home"}
            underline="hover"
            color="text.secondary"
            href="/"
            sx={{ display: 'flex', alignItems: 'center', fontSize: "80%" }}>
                    <HomeIcon sx={{ mr: 0.5 }} fontSize={"inherit"} />Home</Link>)

        //middle crumbs
        props.crumbs.slice(0,-1).forEach((crumb,i) => crumbList.push(
            crumb.hasOwnProperty("href") ?
                <Link key={i}
                    underline="hover"
                    color="text.secondary"
                    href={crumb.href}
                    sx={{ display: 'flex', alignItems: 'center', fontSize: "80%" }}>{crumb.title}</Link> :
                <Typography key={i}
                    sx={{ display: 'flex', alignItems: 'center', fontSize: "80%" }}
                    color="text.secondary">
                    {crumb.title}
                </Typography>
        ))

        // last crumb
        props.crumbs.slice(-1).forEach((crumb,i) => crumbList.push(<Typography
            key={i}
            sx={{ display: 'flex', alignItems: 'center', fontSize: "80%" }}
            color="text.secondary">
              {crumb.title}
            </Typography>
        ))
    }

    return <Breadcrumbs
        separator={<NavigateNextIcon fontSize="80%" />}
        aria-label="breadcrumb"
        sx={{ mt: 1, mb: 1 }}>
                {crumbList}
            </Breadcrumbs>
}